import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionTimeoutModalComponent } from './session-timeout-modal/session-timeout-modal.component';
import { SessionTimeoutComponent } from './session-timeout/session-timeout.component';
import { AutofocusDirective } from '@app/shared/directives/autofocus.directive';

@NgModule({
  declarations: [SessionTimeoutModalComponent, SessionTimeoutComponent],
  exports: [SessionTimeoutComponent],
  imports: [
    CommonModule,
    // standalone components
    AutofocusDirective,
  ],
})
export class SessionModule {}
